import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import KushkiButtons from './components/kushki-buttons';
import formatPriceToFloat from '../../../../utils/price/format-price-to-float';
import KushkiPaymentForm from './kushki-payment-form';
import { addPaymentError, changeState } from '../../reducers';
import { getZeroInDecimal } from '../../../../utils/price/get-zero-in-decimal';
import { LATINA_COUNTRY_CODE } from '../../../../constants/latina-country';
import { resolvePreselectedPaymentOption } from '../../payment.helpers';

const KushkiPaymentPage = () => {
    const dispatch = useDispatch();
    const currency = useSelector((state: RootState) => state.main.currency);
    const { paymentOptionsData, activePaymentOption, paymentCart } = useSelector((state: RootState) => state.payment);
    const [cartFinalPrice, setCartFinalPrice] = useState(0);

    useEffect(() => {
        if (!paymentOptionsData?.loaded) {
            return;
        }

        const defaultOption = resolvePreselectedPaymentOption(paymentOptionsData);

        if (defaultOption) {
            dispatch(changeState({ activePaymentOption: defaultOption }));
        }
    }, [paymentOptionsData]);

    useEffect(() => {
        if (paymentCart?.loaded) {
            setCartFinalPrice(formatPriceToFloat(paymentCart?.finalPrice) || 0);
        }
    }, [paymentCart?.loaded]);

    useEffect(() => {
        if (!activePaymentOption || !currency.loaded) {
            return;
        }

        if (paymentLimitCheck(paymentOptionsData?.kushkiEnv?.limits?.[activePaymentOption.id])) {
            dispatch(addPaymentError({
                message: paymentLimitErrorMessage(paymentOptionsData?.kushkiEnv?.limits?.[activePaymentOption.id])
            }));
        }
    }, [activePaymentOption, currency.loaded]);

    const paymentLimitCheck = (paymentTypeLimit: string | undefined) => {
        return cartFinalPrice.toFixed(2) < (paymentTypeLimit || '');
    }

    const paymentLimitErrorMessage = (paymentTypeLimit: number | string | undefined) => {
        const limit = Number(paymentTypeLimit || '');
        const message =
            [LATINA_COUNTRY_CODE.CL, LATINA_COUNTRY_CODE.CO].includes(paymentOptionsData?.userCountry as LATINA_COUNTRY_CODE)
                ? limit - getZeroInDecimal(cartFinalPrice)
                : (Number(limit.toFixed(2)) - Number(cartFinalPrice.toFixed(2))).toFixed(2);

        return `Estimado cliente, lamentablemente aún no ha alcanzado el valor mínimo del pedido. Por favor, añada ${message} ${currency.code} más a su cesta de la compra. Lamentamos las molestias.`;
    };

    if (!paymentOptionsData) {
        return <></>;
    }

    return (
        <>
            {Boolean(cartFinalPrice > 0) && (
                <>
                    <KushkiButtons />
                    <KushkiPaymentForm />
                </>
            )}
        </>
    );
};

export default KushkiPaymentPage;
